module.exports = __webpack_public_path__ + "static/img/gcon-big-pie.f83bb92.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/gcon-big-pie.jpg
// module id = CBq0
// module chunks = 0